/**
 * Formata um número com pontuação brasileira (separador de milhares: ponto, separador decimal: vírgula)
 * @param valor - Valor numérico ou string que representa um número
 * @returns String formatada com pontuação brasileira ou o valor original se não for numérico
 */
export function formatarNumero(valor: number | string | null | undefined): string {
  if (valor === null || valor === undefined || valor === '') return '';
  
  // Se já for número, usa diretamente
  if (typeof valor === 'number') {
    if (!isFinite(valor)) return '';
    if (Number.isInteger(valor)) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } else {
      // Para decimais, detecta casas decimais significativas
      const str = valor.toString();
      const partes = str.split('.');
      const casasDecimais = partes[1]?.length || 0;
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: Math.min(casasDecimais, 4), 
        maximumFractionDigits: Math.min(casasDecimais, 4) 
      });
    }
  }
  
  // Se for string, tenta converter
  const strValor = String(valor).trim();
  if (strValor === '') return '';
  
  // Remove caracteres não numéricos exceto ponto e vírgula
  const numStr = strValor.replace(/[^\d.,-]/g, '').replace(',', '.');
  const num = parseFloat(numStr);
  
  if (isNaN(num) || !isFinite(num)) {
    // Se não for número válido, retorna o valor original
    return strValor;
  }
  
  // Verifica se é inteiro
  if (Number.isInteger(num)) {
    return num.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  } else {
    // Para decimais, mantém casas decimais originais (máximo 4)
    const partes = numStr.split('.');
    const casasDecimais = Math.min(partes[1]?.length || 0, 4);
    return num.toLocaleString('pt-BR', { 
      minimumFractionDigits: casasDecimais, 
      maximumFractionDigits: casasDecimais 
    });
  }
}
